// extracted by mini-css-extract-plugin
export default {"AppInfoSection":"AppInfoSection_AppInfoSection__PVFBm"};